module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/point3_78ab7f92cea4ea4d3cf2a9b919e47f90.png";